document.addEventListener('DOMContentLoaded', function () {
    (function () {
        let tabsElements = document.querySelectorAll('.tabs');

        if(tabsElements) {
            for (let i = 0; i < tabsElements.length; i++) {
                setupTabs(tabsElements[i]);
            }

            function setupTabs (tabsElement) {
                console.log(tabsElement)
                let tabsNavigationItems = tabsElement.querySelectorAll('.tabs__item'),
                    tabsContentAreas = tabsElement.querySelectorAll('.tabs__content');

                for (let i = 0; i < tabsContentAreas.length; i++) {
                    tabsNavigationItems[i].classList.remove('is-active');
                    tabsContentAreas[i].classList.remove('is-active');

                    ((i) => {
                        tabsNavigationItems[i].addEventListener('click', onTabClick(tabsElement, i));
                    })(i);
                }

                if(tabsNavigationItems[0]) {
                    tabsNavigationItems[0].classList.add('is-active');
                    tabsContentAreas[0].classList.add('is-active');
                }
            }

            function onTabClick (tabsContainer, index) {
                return ((event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    const activeTab = tabsContainer.querySelector('.tabs__item.is-active');
                    const activeTabContainer = tabsContainer.querySelector('.tabs__content.is-active');
                    const tabsContent = tabsContainer.querySelectorAll('.tabs__content');

                    activeTab.classList.remove('is-active');
                    activeTabContainer.classList.remove('is-active');

                    event.currentTarget.classList.add('is-active');
                    tabsContent[index].classList.add('is-active');
                });
            }
        }
    })();
});
